import type { MarketsApi } from "@/v2/api/metadata/markets";
import {
  addFeedMappingRow,
  buildFeedMappingGrid,
  createFeedMappingSubmitGate,
  fetchFeedTypeMappingsList,
} from "@/v2/kits/feed-mapping";
import type { GridTab, GridTabSaveContext } from "@/v2/framework/dialog/types";
import { marketId, notifySuccess } from "../shared";

export function createFeedMappingTab(marketsApi: MarketsApi): GridTab {
  async function save(ctx: GridTabSaveContext): Promise<void> {
    const gate = ctx.gate;
    if (!gate?.hasSuccessfulLoad() || !gate.isDirty()) return;
    if (!gate.validateForDialogSubmit()) {
      throw new Error("Please fill the required fields");
    }

    const fragment = gate.buildMergeFragment();
    if (!fragment) return;

    const entityId = marketId(ctx.values);
    await marketsApi.update(entityId, fragment);

    if (!ctx.rows) throw new Error("Feed mapping grid is not available");

    ctx.rows.value = await fetchFeedTypeMappingsList(marketsApi.getFeedTypeMappings, entityId, {
      isReadAfterWrite: true,
    });
    gate.markClean?.();
    notifySuccess();
  }

  return {
    kind: "grid",
    id: "feed-mapping",
    label: "Feed mapping",
    createGrid: (getValues) =>
      buildFeedMappingGrid(
        () => marketId(getValues()),
        marketsApi.getFeedTypeMappings.bind(marketsApi),
      ),
    createSubmitGate: createFeedMappingSubmitGate,
    save,
    addRowLabel: "common.buttons.add_new",
    onAddRow: addFeedMappingRow,
  };
}
